<div class="dialog">
  <h1>Download QR-Code</h1>
  <div class="qr-container">
    <qrcode [qrdata]="content" [width]="1024" [errorCorrectionLevel]="'L'" #qrCode></qrcode>
  </div>

  <button appButton name="download" location="qr-code-dialog" color="primary" data-test-id="download-qr" (click)="downloadQrCode()" height="4"
    size="3" weight="bold" spacing="8" [center]="true" shape="round">
    Download
  </button>
</div>
